<template>
	<PopUp
		title="Abonnement bearbeiten"
		size="lg"
		ok-text="Speichern"
		:ok-disabled="saving"
		:ok-loading="saving"
		@ok="save"
		@hidden="$emit('hidden')"
	>
		<Loading v-if="loading"/>
		<template v-else>
			<FormGroup label="Automatische Verlängerung" :label-classes="['font-weight-bold']">
				<b-form-checkbox v-model="autoRenew">
					Das Abonnement soll sich am Ende der Laufzeit automatisch verlängern.
				</b-form-checkbox>
			</FormGroup>
			<FormGroup label="Produkt" :label-classes="['font-weight-bold']" class="mt-4">
				<div class="mb-1">Die Änderung des Produkts wird zur nächsten Verlängerung wirksam.</div>
				<Select
					v-model="followUpProductId"
					:options="productOptions"
					:empty-value="null"
					empty-value-label="Keine Produktänderung"
				/>
			</FormGroup>
		</template>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp.vue";
import FormGroup from "@/vue/common/form/Group.vue";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import Save from "@/api/customer/subscription/Save";
import GetList from "@/api/product/GetList";
import {SUBSCRIPTION} from "@/helper/product/Category";
import Loading from "@/vue/common/Loading.vue";
import Select from "@/vue/common/form/Select.vue";

export default {

	components: {
		Select,
		Loading,
		FormGroup,
		PopUp
	},

	props: {
		subscription: {
			type: Object,
			required: true,
		},
	},

	mounted ()
	{
		this.loadProducts();
	},

	data ()
	{
		return {
			loading: true,
			products: undefined,
			autoRenew: this.subscription.autoRenew,
			followUpProductId: this.subscription.followUpProductId,
			saving: false
		};
	},

	computed: {
		productOptions ()
		{
			let products = this.products;

			if (!this.followUpProductId)
			{
				products = this.products.filter(product => product.id !== this.subscription.productId);
			}

			return _.map(products, product =>
			{
				return {
					value: product.id,
					text: product.label
				};
			});
		},
	},

	methods: {
		async loadProducts ()
		{
			this.loading = true;

			const response = await new GetList()
				.setCategory(SUBSCRIPTION)
				.call();

			this.products = response.data;

			this.loading = false;
		},
		async save ()
		{
			this.saving = true;

			try
			{
				await new Save()
					.setAutoRenew(this.autoRenew)
					.setFollowUpProduct(
						this.followUpProductId && this.followUpProductId !== this.subscription.productId
							? this.followUpProductId
							: null
					)
					.call();

				this.$emit('change');

				Toast.success(this, ['Erfolgreich gespeichert']);
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		}
	}
}
</script>
